module.exports = __webpack_public_path__ + "img/logoblk-en.0a89bcbe.svg";